import React from "react";
import Box from '@mui/joy/Box';
import { Outlet, Link } from "react-router-dom";

import DiscordButton from "./DiscordButton";
import Footer from "./Footer";
import logo from "../assets/pfs_logo.png";
import './styles/navigator.css'

const Navigator = () => {
    return (
        <Box className='page-content pattern'>
            <Box className='navigator-bar'>
                <Box className='navigator-links'>
                    <Link className='link link-logo' to="/">
                        <img className='logo-home' src={logo} alt="Paramore Fan Server Logo" />
                    </Link>
                    <Link className='link' to="/">Home</Link>
                    <Link className='link' to="/leaderboard">Leaderboard</Link>
                    <Link className='link' to="https://store.paramore.net/">Store</Link>
                </Box>
                <DiscordButton/>
            </Box>
            <Outlet/>
            <Footer/>
        </Box>
    )
};

export default Navigator;
